<template>
    <v-menu v-model="menu" :close-on-content-click="false">
        <template v-slot:activator="{props}">
            <v-btn color="primary" icon="mdi-mail" variant="text" v-bind="props" />
            <send-clients-email-modal v-model="emailModal" :emails="emails" @sent="orders = []" />
        </template>
        <v-card>
            <v-card-title>{{ $t('send_email') }} {{ $t('emails_for') }}</v-card-title>
            <v-card-text>
                <v-checkbox v-model="emailFor" value="suppliers" :label="$t('emails_for_suppliers')" />
                <v-checkbox v-model="emailFor" value="clients" :label="$t('emails_for_clients')" />
                <v-checkbox v-model="emailFor" value="travelers" :label="$t('emails_for_travelers')" />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    :disabled="!emailFor.length || loading"
                    :loading="loading"
                    color="primary"
                    variant="flat"
                    block
                    @click="select"
                >
                    {{ $t('select') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
    import {Component, VModel} from 'vue-facing-decorator'
    import SendClientsEmailModal from '@/components/account/modals/SendClientsEmailModal.vue'
    import {OrderEmailsMixin} from '@/components/account/mixins/OrderEmailsMixin.vue'

    @Component({
        components: {SendClientsEmailModal},
    })
    export class OrderEmailsMenu extends OrderEmailsMixin {
        @VModel() orders

        menu = false
        loading = false
        emailModal = false
        emails = []

        async select() {
            this.loading = true
            this.emails = await this.getOrderEmails(this.orders)
            this.menu = false
            this.emailModal = true
            this.loading = false
        }
    }

    export default OrderEmailsMenu
</script>
